/* eslint-disable */
import React,{useState,useEffect} from "react";
import { IconButton } from "@mui/material";
import { MdDelete } from "react-icons/md";
import { deleteProcessedData } from "../../../Api";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const DataTable = ({ rows = [], setRows, processedData, onDelete }) => {
    useEffect(() => {
    if (rows && rows.length > 0) {
      localStorage.setItem("tableRows", JSON.stringify(rows));
    }
  }, [rows]);
  
   // Load rows from localStorage on first load
  useEffect(() => {
    const savedRows = localStorage.getItem("tableRows");
    if (savedRows) {
      setRows(JSON.parse(savedRows));
    }
  }, []);

  const navigate = useNavigate();

  const getFileTypeLabel = (fileType) => {
    const fileTypeMap = {
      'OFAC_SDN': 'OFAC SDN',
      'OFAC_NON_SDN': 'OFAC NON-SDN', 
      'UK_Sanctions': 'UK Sanctions',
      'PEP': 'PEP',
      'GREY_LIST': 'Grey List',
      'WHITE_LIST': 'White List'
    };
    return fileTypeMap[fileType] || fileType;
  };

  const handleDelete = async (row, index) => {
    // if (!processedData) {
    //   setRows((prevRows) => prevRows.filter((_, i) => i !== index)); // Remove only the row at the specified index
    //   return;
    // }
if (!processedData) {
  setRows((prevRows) => {
    const updatedRows = prevRows.filter((_, i) => i !== index);
    if (updatedRows.length > 0) {
      localStorage.setItem("tableRows", JSON.stringify(updatedRows));
    } else {
      localStorage.removeItem("tableRows");
    }
    return updatedRows;
  });
  return;
}

    const result = await Swal.fire({
      text: "Are you sure you want to delete this data?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes"
    });

    if (result.isConfirmed) {
      try {
        // Show loading indicator
        Swal.fire({
          html: `<img src=${require("../../../assets/loader.gif")} style="width: 50px" alt="loader">`,
          showConfirmButton: false,
          heightAuto: false,
          customClass: { popup: "loader-swal" },
          allowOutsideClick: false
        });

        const getFileType = () => {
          // First check if file_type is explicitly set
          if (row.file_type) return row.file_type;

          // Infer from filename if not explicitly set
          const fileName = Array.isArray(row.fileName) ? row.fileName[0] : row.fileName;
          // Convert to lowercase for case-insensitive comparison
          const fileNameLower = fileName.toLowerCase();
          
          if (fileNameLower.includes('ofac') && !fileNameLower.includes('nonsdn')) return 'OFAC_SDN';
          if (fileNameLower.includes('uk')) return 'UK_Sanctions';
          if (fileNameLower.includes('nonsdn')) return 'OFAC_NON_SDN';
          if (fileNameLower.includes('pep')) return 'PEP';
          if (fileNameLower.includes('grey')) return 'GREY_LIST';
          if (fileNameLower.includes('white')) return 'WHITE_LIST';
          return 'OFAC_SDN'; // Default
        };       

        const fileName = Array.isArray(row.fileName) ? row.fileName[0] : row.fileName;
        const scenario = Array.isArray(row.scenario) ? row.scenario : [row.scenario];
        const bankCode = localStorage.getItem("bank_code") || "";
        const correlId = localStorage.getItem("correl_id") || "";
        const fileType = getFileType();

        // Validate required parameters
        if (!fileName) {
          throw new Error("Missing file name");
        }
        if (!scenario || scenario.length === 0) {
          throw new Error("Missing scenario");
        }
        if (!bankCode) {
          throw new Error("Missing bank code");
        }
        if (!correlId) {
          throw new Error("Missing correl ID");
        }
        if (!row.processed_id) {
          throw new Error("Missing processed ID - Cannot delete without a valid processed ID");
        }

        const deleteParams = {
          file_type: fileType,
          file_name: fileName,
          bank_code: bankCode,
          correl_id: correlId,
          scenario: scenario,
          processed_id: row.processed_id
        };

        console.log("Delete params:", deleteParams);
        const response = await deleteProcessedData(deleteParams);
        console.log("Delete response:", response);
        Swal.close();

        if (response?.status === "S") {
          await Swal.fire({
            text: response.message || "Data deleted successfully!",
            icon: "success",
            showConfirmButton: false,
            heightAuto: false,
            timer: 3000
          });
          
          // Call onDelete callback to refresh the table
          if (onDelete) {
            onDelete(row.id);
          }
          
        } else if (response?.status === "F" && 
                  (response?.message?.includes("Unauthorized") || 
                   response?.message?.includes("Invalid token"))) {
          // Handle authentication errors
          await Swal.fire({
            text: "Please login again to continue",
            icon: "warning",
            showConfirmButton: false,
            timer: 3000
          });
          localStorage.clear();
          navigate("/login");
        } else {
          Swal.fire({
            text: response?.message || "Error deleting data",
            icon: "error",
            showConfirmButton: true,
            heightAuto: false
          });
        }
      } catch (error) {
        console.error("Delete error:", error);
        Swal.close();
        Swal.fire({
          text: error.message || "Error deleting data",
          icon: "error", 
          showConfirmButton: true,
          heightAuto: false
        });
      }
    }
  };

  return (
    <div className="table-responsive mb-3">
      <table className="table table-bordered table-striped">
        <thead className="table-dark">
          <tr>
            <th>Current/History</th>
            <th>File Type</th>
            <th>File Name</th>
            <th>Scenario</th>
            {!processedData && <th>Actions</th>}
          </tr>
        </thead>
        <tbody>
          {rows?.length > 0 && rows.map((row, index) => (
            <tr key={row.id}>
              <td>{row.type}</td>
              <td>{getFileTypeLabel(row.file_type)}</td>
              <td>
                {Array.isArray(row.fileName)
                  ? row.fileName.join(", ")
                  : row.fileName}
              </td>
              <td>
                {(row.scenario_type === "Positive" || row.scenario_type === "Negative")
                  ? row.scenario_type
                  : (Array.isArray(row.scenario)
                      ? row.scenario.join(", ")
                      : row.scenario)}
              </td>
              {!processedData && <td> 
                <IconButton
                  color="error"
                  size="small"
                  onClick={() => handleDelete(row, index)} // Pass index to handleDelete
                >
                  <MdDelete />
                </IconButton>
              </td>}
            </tr>
          ))}
          {rows.length === 0 && (
            <tr>
              <td colSpan="5" className="text-center">
                No data selected for processing
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;